import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import NftCollectionViewLayer from "../../components/NFT/NftCollectionViewLayer";

const NftCollectionViewPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="NFT Collection View" />

                    <NftCollectionViewLayer />
               </MasterLayout>
          </>
     );
};

export default NftCollectionViewPage;
